import { createContext } from 'react';
import {
  SegmentTrackProperties,
  SegmentPageProperties,
} from './AnalyticsProvider.d';

export enum AnalyticsEvent {
  DEAL_OF_THE_WEEK_VIEWED = 'Deal of the Week Viewed',
  DEAL_OF_THE_WEEK_BUTTON_CLICKED = 'Deal of the Week Button Clicked',
  SUPER_HERO_CONTENT_BLOCK_CLICK = 'Super Hero Content Block Click',
  RIBBON_CONTENT_BLOCK_CLICKED = 'Ribbon Content Block Clicked',
  CONTINUE_WITHOUT_OFFER = 'Continue Without Offer',
  EXIT_INTENT_EMAIL_SUBMITTED = 'Exit Intent Email Submitted',
  PRODUCT_CLICKED = 'Product Clicked',
  BEST_SELLERS_PRODUCT_LIST_CONTENT_BLOCK_CLICK = 'Best Sellers Product List Content Block Click',
  PRIMARY_NAVIGATION_CLICK = 'Primary Navigation Click',
  PRODUCT_CATEGORY_VIEWED = 'Product Category Viewed',
  VASE_REMOVED = 'Vase Removed',
  CART_UPDATED = 'Cart Updated',
  ADDON_ADD = 'Addon Add',
  ADDON_REMOVE = 'Addon Remove',
  PRODUCT_REMOVED = 'Product Removed',
  DELIVERY_DATE_SELECTED = 'Delivery Date Selected',
  DELIVERY_DATE_OPENED = 'Delivery Date Opened',
  PRODUCT_TILE_VIEWED = 'Product Tile Viewed',
  PRODUCT_VIEWED = 'Product Viewed',
  PRODUCT_ADDED = 'Product Added',
  VARIANT_SELECTED = 'Variant Selected',
  OPT_IN = 'Opt In',
  OPT_OUT = 'Opt Out',
  PDP_VASE_TREATMENT_REMOVE_VASE_LABEL_CLICKED = 'PDP Vase Treatment Remove Vase Label Clicked',
  PDP_VASE_TREATMENT_ADD_VASE_LABEL_CLICKED = 'PDP Vase Treatment Add Vase Label Clicked',
  PDP_VASE_TREATMENT_KEEP_VASE_BUTTON_CLICKED = 'PDP Vase Treatment Keep Vase Button Clicked',
  PDP_VASE_TREATMENT_REMOVE_VASE_BUTTON_CLICKED = 'PDP Vase Treatment Remove Vase Button Clicked',
  VIEW_FARMER = 'View Farmer',
  CART_VIEWED = 'Cart Viewed',
  VIEWED_CHECKOUT_STEP = 'Viewed Checkout Step',
  CART_ADDON_VIEW = 'Cart Addon View',
  CART_DRAWER_SUBSCRIBER_VIEW = 'Cart Drawer Subscriber View',
  FLORIST_ZIP_AVAILABLE = 'Florist Zip Available',
  FLORIST_ZIP_UNAVAILABLE = 'Florist Zip Unavailable',
}

declare global {
  interface Window {
    analytics: {
      track: (string, SegmentTrackProperties) => void;
      page: (string, SegmentPageProperties) => void;
    };
  }
}

export type AnalyticsContextInterface = {
  track: (event: AnalyticsEvent, properties: SegmentTrackProperties) => void;
  page: (name: string, properties?: SegmentPageProperties) => void;
};

const AnalyticsContext = createContext<AnalyticsContextInterface>({
  track: () => null,
  page: () => null,
});

export default AnalyticsContext;
